<script setup lang="ts">
import { computed } from 'vue';

import { formatFloatAmount } from '@/helpers/formatters';
import { AmountMode } from '@/references/axios/transactions/types';
import { CurrencyCode } from '@/references/currency';
import type { TokenWithEurPrice } from '@/references/tokens';

import TokenInfo from '@/components/TokenInfo.vue';

interface Props {
  token: TokenWithEurPrice;
}

const props = defineProps<Props>();

const formattedPrice = computed((): string => {
  return formatFloatAmount(
    props.token.priceEUR,
    CurrencyCode.EUR,
    2,
    10,
    AmountMode.SymbolFirst,
    false
  );
});
</script>

<template>
  <TokenInfo
    :token="props.token"
    :description="props.token.symbol"
    :value="formattedPrice"
    :volatility="props.token.priceChange"
  />
</template>
